import React from 'react'
import SliderComponent from './ImageSlider'

import img1 from '../../assets/ads//bhoomi/1.gif';
import img2 from '../../assets/ads//bhoomi/2.jpg';
import img3 from '../../assets/ads//bhoomi/3.jpg';



function BhoomiSlider() {
  return (
    <div className='bhoomiAds'>
      <SliderComponent
      
          images={[
            { image: img1, title: "", description: "",url:"/register" },
            { image: img2, title: "", description: "" ,url:"/register"},
            { image: img3, title: "", description: "" ,url:"/register"},
      

          ]}
          duration={5000}
        //   titleStyle="text-sm font-semibold bg-black bg-opacity-60 px-3 py-1 rounded"
        //   descriptionStyle="text-xs bg-black bg-opacity-40 px-2 py-1 rounded"
          allowFade={true}
          showBullet={false}     // Correct prop name (from SliderComponent.jsx)
          showArrowIcons={false}
          containerWidth="100%" // Adjusted to fit the container
          containerHeight="300px"
        //   headflash={["Find your dream home", "Exclusive listings","Register Free","Nominal Subscription", "Hurry! Limited time offers","Seamleass User Experience"]}
        //   headflashstyle="custom-headflash"
        //   headflashduration={2000}
      
      
      
      
      >

      </SliderComponent>
    </div>
  )
}

export default BhoomiSlider
